import React from 'react';
import { motion } from 'framer-motion';
import { T } from '../lib/lang';

const LINKS = {
  ponchik: 'https://t.me/ponchiknews',
  ppprompt: 'https://t.me/ppprompt',
  level3: 'https://talkauthentic.io/level3',
  space: 'https://aimindset.org/ai-mindset-community',
};

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-border pt-24">
      {/* Background Art */}
      <div className="pointer-events-none absolute inset-0">
        <img
          src="/assets/cover-main.png"
          alt=""
          className="h-full w-full object-cover opacity-35 [filter:saturate(1.05)_contrast(1.05)]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-bg/40 via-bg/70 to-bg" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,163,115,0.18),transparent_55%)]" />
      </div>

      <div className="relative mx-auto grid max-w-6xl gap-10 px-6 pb-14 pt-10 md:grid-cols-[1fr_280px] md:gap-16 md:pb-20">
        <div>
          <div className="mb-6 inline-flex items-center gap-3 rounded border border-border bg-bg/40 px-3 py-2 text-[10px] uppercase tracking-[0.25em] text-muted backdrop-blur">
            <span>FOS#14</span>
            <span className="text-dim">·</span>
            <span>18.12.2025</span>
            <span className="text-dim">·</span>
            <span>Founder OS</span>
          </div>

          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="font-serif text-5xl font-light italic leading-[1.05] tracking-[-0.03em] text-text md:text-6xl"
          >
            IFS + AI
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: 'easeOut' }}
            className="mt-4 max-w-2xl text-base leading-8 text-muted"
          >
            <T
              ru={
                <>
                  <span className="text-text">«Конечный результат</span>{'\u00A0—\u00A0'}не чего-то добиться, а скорее{' '}
                  <span className="text-text">от себя отстать»</span>. IFS + AI
                  {'\u00A0—\u00A0'}нейросеть как <span className="text-text">суфлёр</span> для диалога с внутренними частями
                  {'\u00A0—\u00A0'}через <span className="text-text">контекст</span> и{' '}
                  <span className="text-text">визуальные метафоры</span>.
                </>
              }
              en={
                <>
                  <span className="text-text">“The end result</span>{'\u00A0—\u00A0'}isn’t achievement, but{' '}
                  <span className="text-text">letting yourself be”</span>. IFS + AI
                  {'\u00A0—\u00A0'}AI as a <span className="text-text">prompter</span> for inner parts work
                  {'\u00A0—\u00A0'}via <span className="text-text">context</span> and <span className="text-text">visual metaphors</span>.
                </>
              }
            />
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
            className="mt-8 flex flex-wrap items-center gap-3"
          >
            <a
              href="#video"
              className="inline-flex items-center gap-2 rounded bg-text px-5 py-3 text-[11px] font-medium uppercase tracking-widest text-bg transition-opacity hover:opacity-90"
            >
              <T ru="смотреть видео" en="watch video" />
              <span aria-hidden>→</span>
            </a>
            <a
              href={LINKS.level3}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded border border-border bg-bg/30 px-5 py-3 text-[11px] uppercase tracking-widest text-text transition-colors hover:border-gold hover:text-gold"
            >
              <T ru="TalkAuthentic · Level 3" en="TalkAuthentic · Level 3" />
              <span aria-hidden>↗</span>
            </a>
            <a
              href={LINKS.space}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded border border-border bg-bg/30 px-5 py-3 text-[11px] uppercase tracking-widest text-text transition-colors hover:border-gold hover:text-gold"
            >
              <T ru="join {space}" en="join {space}" />
              <span aria-hidden>↗</span>
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-10 flex flex-wrap items-center gap-4 text-[12px] text-dim"
          >
            <span className="uppercase tracking-widest text-dim">links</span>
            <span className="text-dim">·</span>
            <a className="text-muted underline-offset-4 hover:text-text hover:underline" href={LINKS.ponchik} target="_blank" rel="noreferrer">
              @ponchiknews
            </a>
            <a className="text-muted underline-offset-4 hover:text-text hover:underline" href={LINKS.ppprompt} target="_blank" rel="noreferrer">
              @ppprompt
            </a>
          </motion.div>
        </div>

        {/* Speaker card */}
        <motion.aside
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: 'easeOut' }}
          className="self-start rounded-lg border border-border bg-bg/40 p-6 backdrop-blur"
        >
          <div className="mx-auto mb-4 h-40 w-40 overflow-hidden rounded-full border border-border bg-card">
            <img
              src="/assets/ivanov.jpg"
              alt="Алексей Иванов"
              className="h-full w-full object-cover grayscale transition-[filter] duration-500 hover:grayscale-0"
            />
          </div>
          <div className="text-center">
            <div className="text-sm font-medium text-text">
              <T ru="алексей иванов" en="alexey ivanov" />
            </div>
            <div className="mt-2 text-[11px] leading-6 text-dim">
              <T
                ru={
                  <>
                    executive-коуч для фаундеров и лидеров
                    <br />
                    амстердам · ru/en
                  </>
                }
                en={
                  <>
                    executive coach for founders & leaders
                    <br />
                    amsterdam · ru/en
                  </>
                }
              />
            </div>
          </div>
        </motion.aside>
      </div>
    </section>
  );
}
